import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConfig } from './api.config';

@Injectable({
  providedIn: 'root'
})
export class ComissaoService extends ApiConfig {
  dicionarioData: Object;

  constructor(private http: HttpClient) {
    super();
  }
  listarDicionario() {
    try {
      if (this.dicionarioData)
        return new Promise(async (resolve) => {
          resolve(this.dicionarioData);
        });
      return new Promise(async (resolve) => {
        this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Comissao/listarDicionario')
          .subscribe(data => {
            this.dicionarioData = data;
            resolve(data);
          }, error => {
          });
      });
    } catch (error) {
      alert(error);
    }
  }

  listar(filtro) {
    try {
      return new Promise(async (resolve) => {

        this.http.post('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Comissao/Listar',
          filtro)
          .subscribe(data => {
            resolve(data);
          }, error => {


          });
      });
    } catch (error) {
      alert(error);
    }
  }

  listarPorParlamentar(idParlamentar) {
    try {
      return new Promise(async (resolve) => {

        this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Comissao/ListarPorParlamentar?idParlamentar=' + idParlamentar)
          .subscribe(data => {
            resolve(data);
          }, error => {


          });
      });
    } catch (error) {
      alert(error);
    }
  }

  graficoMembroPartido(id) {
    try {
      return new Promise(async (resolve) => {

        this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Comissao/GraficoMembroPartido?id=' + id)
          .subscribe(data => {
            resolve(data);
          }, error => {
          });
      });
    } catch (error) {
      alert(error);
    }
  }

  obter(filtro) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Comissao/Obter?id=' + filtro.Id)
        .subscribe(data => {
          resolve(data);
        }, error => {


        });
    });
  }
  listarHistoricoMembro(id) {
    return new Promise(async (resolve) => {
      this.http.get('https://project-5082f113-c983-477a-973.uw.r.appspot.com/Comissao/ListarHistoricoMembro?id=' + id)
        .subscribe(data => {
          resolve(data);
        }, error => {
        });
    });
  }
}

